// extracted by mini-css-extract-plugin
module.exports = {"spacingBottom":"LinkNewIds_spacingBottom_3rMiu","search":"LinkNewIds_search_1Pu15"};